module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiByp8kv8JHgFVrLDz8Z1xlFd2JQEk.9ddc0491.woff2";